//#region src/specs/nodes/hard-break-spec.ts
var e = {
	inline: !0,
	group: "inline",
	selectable: !1,
	parseDOM: [{ tag: "br" }],
	toDOM() {
		return ["br"];
	}
};
//#endregion
export { e as hardBreakSpec };
